const _ = require('lodash');


export default {

    sortObject(obj) {
        let listSortedObj = this.findAndOrderLists(obj)
        return this.sortObjectByKeys(listSortedObj)
    },

    /**
     * Recursively iterates over an object and any sub-objects, and sorts any arrays it finds.
     * If the arrays contain objects, it will sort by the first key it finds that has a value in the objects.
     * If the arrays contain primitives, it will sort them in ascending order.
     * @param {Object} obj the object to search and sort
     * @returns {Object} the sorted object
     */
    findAndOrderLists(obj) {
        let newObj = _.cloneDeep(obj)
        for (const key in newObj) {
            if (Array.isArray(newObj[key])) {
                if (typeof newObj[key][0] === 'object') {
                    let sortKey = Object.keys(newObj[key][0]).find((k) => newObj[key][0][k] !== null)
                    newObj[key] = this.sortArrayOfObjects(newObj[key], sortKey)
                }
                else newObj[key].sort()
            } else if (typeof newObj[key] === 'object') {
                this.findAndOrderLists(newObj[key])
            }
        }
        return newObj
    },

    /**
     * Sorts an object by its keys.
     * @param {Object} obj - the object to sort
     * @returns {Object} a new object with sorted keys
     */
    sortObjectByKeys(obj) {
        const sortedKeys = Object.keys(obj).sort()
        const sortedObj = {}
        for (const key of sortedKeys) {
            sortedObj[key] = obj[key]
        }
        return sortedObj
    },

    /**
     * Sorts an array of objects based on a key.
     * @param {Array<Object>} arr - the array to sort
     * @param {string} key - the key to sort by
     * @returns {Array<Object>} a new array with sorted objects
     */
    sortArrayOfObjects(arr, key) {
        return arr.sort((a, b) => {
            if (a[key] < b[key]) {
                return -1
            } else if (a[key] > b[key]) {
                return 1
            } else {
                return 0
            }
        })
    },

    /**
     * Collect param ids from selected items, expanding display_name_group into individual ids.
     * @param {Array<Object>} items - selected items (may have display_name_group)
     * @param {Object} options - { idKey: 'id'|'value', parseInteger: boolean }
     * @returns {Array<number|string>}
     */
    collectIdsFromSelection(items, options = {}) {
        const { idKey = 'id', parseInteger = true } = options
        if (!items || !items.length) return []
        const ids = []
        items.forEach((m) => {
            if (!m.display_name_group) {
                const id = m[idKey]
                if (id != null) ids.push(id)
            } else {
                ids.push(...m.display_name_group)
            }
        })
        return parseInteger ? ids.map((i) => parseInt(i, 10)).filter((n) => !Number.isNaN(n)) : ids
    },

    /**
     * Returns true if current form state differs from the state when the panel was opened.
     * Used for persistDialog / "unsaved changes" in filter panels.
     * @param {Object} currentState - current form/panel values
     * @param {Object} openState - state when dialog opened (e.g. panelOpenState)
     * @returns {boolean}
     */
    hasFormStateChanged(currentState, openState) {
        if (!openState || Object.keys(openState).length === 0) return false
        return JSON.stringify(this.sortObject(currentState)) !== JSON.stringify(this.sortObject(openState))
    },

    /**
     * Attach editor, chipText, tooltipData (and optional grouper) to a filter object.
     * @param {Object} filter - filter object with type, id, params
     * @param {Object} descriptor - { editor, editorParams, chipText, tooltipData, grouper? }
     */
    attachFilterDescriptor(filter, descriptor) {
        const { editor, editorParams, chipText, tooltipData, grouper } = descriptor
        const props = {
            editor: { value: editor },
            editorParams: { value: editorParams },
            chipText: { value: chipText },
            tooltipData: { value: tooltipData },
        }
        if (grouper != null) props.grouper = { value: grouper }
        Object.defineProperties(filter, props)
    },
}


